import React from 'react';
import { Collapse, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { CheckResult } from '../hooks/useSEOAnalysisPanel';

const { Text } = Typography;

interface CharCheckProps {
    titleCharCheck: CheckResult;
    bulletCharChecks: CheckResult[];
}

export const CharCheck: React.FC<CharCheckProps> = ({ titleCharCheck, bulletCharChecks }) => {
    return (
        <Collapse
            size="small"
            items={[{
                key: 'chars',
                label: (
                    <Space>
                        <span>📏 字符数检查</span>
                        {titleCharCheck.status !== 'ok' || bulletCharChecks.some(c => c.status !== 'ok') ? (
                            <Tag color="orange">需关注</Tag>
                        ) : (
                            <Tag color="green">通过</Tag>
                        )}
                    </Space>
                ),
                children: (
                    <div>
                        <div style={{ marginBottom: 8 }}>
                            <Space>
                                <Text strong>标题:</Text>
                                <Text type={titleCharCheck.status === 'error' ? 'danger' : titleCharCheck.status === 'warning' ? 'warning' : 'secondary'}>
                                    {titleCharCheck.message}
                                </Text>
                                {titleCharCheck.status === 'error' && <CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                                {titleCharCheck.status === 'warning' && <WarningOutlined style={{ color: '#faad14' }} />}
                                {titleCharCheck.status === 'ok' && <CheckCircleOutlined style={{ color: '#52c41a' }} />}
                            </Space>
                        </div>
                        {bulletCharChecks.map((check, idx) => (
                            <div key={idx} style={{ marginBottom: 4 }}>
                                <Space>
                                    <Text>卖点{idx + 1}:</Text>
                                    <Text type={check.status === 'error' ? 'danger' : check.status === 'warning' ? 'warning' : 'secondary'}>
                                        {check.message}
                                    </Text>
                                    {check.status === 'error' && <CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                                    {check.status === 'warning' && <WarningOutlined style={{ color: '#faad14' }} />}
                                    {check.status === 'ok' && <CheckCircleOutlined style={{ color: '#52c41a' }} />}
                                </Space>
                            </div>
                        ))}
                    </div>
                ),
            }]}
            style={{ marginBottom: 16 }}
        />
    );
};
